import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const UploadPlaceholderSvg = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    viewBox='0 0 150 150'
    fill='none'
  >
    <rect width='1em' height='1em' fill='white' fillOpacity='0.3'></rect>
    <line
      x1='117.256'
      y1='116.55'
      x2='146.999'
      y2='146.293'
      stroke='#DED6C7'
      strokeLinecap='round'
    ></line>
    <line x1='2.70711' y1='2' x2='32.45' y2='31.7429' stroke='#DED6C7' strokeLinecap='round'></line>
    <line
      x1='0.5'
      y1='-0.5'
      x2='42.5628'
      y2='-0.5'
      transform='matrix(0.707107 -0.707107 -0.707107 -0.707107 116.549 32.45)'
      stroke='#DED6C7'
      strokeLinecap='round'
    ></line>
    <line
      x1='0.5'
      y1='-0.5'
      x2='42.5628'
      y2='-0.5'
      transform='matrix(0.707107 -0.707107 -0.707107 -0.707107 2 147)'
      stroke='#DED6C7'
      strokeLinecap='round'
    ></line>
    <rect
      x='0.25'
      y='0.25'
      width='149.5'
      height='149.5'
      rx='6.75'
      stroke='#DED6C7'
      strokeWidth='0.5'
      strokeLinecap='round'
      strokeDasharray='5 5'
    ></rect>
    <path
      d='M57 75C57 65.0589 65.0589 57 75 57C84.9411 57 93 65.0589 93 75C93 84.9411 84.9411 93 75 93C65.0589 93 57 84.9411 57 75Z'
      fill='white'
    ></path>
    <path
      d='M57.5 75C57.5 65.335 65.335 57.5 75 57.5C84.665 57.5 92.5 65.335 92.5 75C92.5 84.665 84.665 92.5 75 92.5C65.335 92.5 57.5 84.665 57.5 75Z'
      fill='white'
      stroke='#DED6C7'
    ></path>
    <path
      d='M75 66.6V83.4'
      stroke='#3F3D56'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    ></path>
    <path
      d='M66.5996 75H83.3996'
      stroke='#3F3D56'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    ></path>
  </svg>
);

export const UploadPlaceholderIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={UploadPlaceholderSvg} {...props} />
);
